import { differenceInCalendarDays, isValid, parseISO } from "date-fns";

const SHORT_TRAVEL_INSURANCE_MAX_DAYS = 180;

/** Whether a travel-insurance contract counts as "short" (< 180 days) or "long". */
export type TravelInsuranceDuration = "short" | "long";

/**
 * Classifies a travel-insurance contract's duration from its start/end dates.
 * Missing or invalid dates default to "long", matching the removed backend
 * resolver's fallback behavior.
 */
export const getTravelInsuranceDuration = (
	startAt: string | null | undefined,
	endAt: string | null | undefined,
): TravelInsuranceDuration => {
	if (!startAt || !endAt) {
		return "long";
	}

	const start = parseISO(startAt);
	const end = parseISO(endAt);
	if (!isValid(start) || !isValid(end)) {
		return "long";
	}

	const durationDays = differenceInCalendarDays(end, start);
	return durationDays < SHORT_TRAVEL_INSURANCE_MAX_DAYS ? "short" : "long";
};
